import { render } from "./IndexCarousel.vue?vue&type=template&id=84fd0038&scoped=true"
import script from "./IndexCarousel.vue?vue&type=script&lang=js"
export * from "./IndexCarousel.vue?vue&type=script&lang=js"

import "./IndexCarousel.vue?vue&type=style&index=0&id=84fd0038&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fd0038"]])

export default __exports__